// src/components/student/SmartLayout.jsx
// Picks the right chrome for pages open to BOTH guests and students.
// Logged-in student → app shell (sidebar); everyone else → marketing Layout.
import React from "react";
import { useAuth } from "../../context/AuthContext";
import { Layout } from "../common/Layout";
import Loader from "../common/Loader";
import StudentLayout from "./StudentLayout";

export default function SmartLayout({ children }) {
  const { role, loading } = useAuth();

  if (loading) return <Loader />;
  if (role === "student") return <StudentLayout>{children}</StudentLayout>;
  return <Layout>{children}</Layout>;
}
